/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';

import {SvgIconReact} from 'common/components/svg-icon';

import styles from './chart-preview.module.styl';

export const ChartPreviewCarousel = ({children}: {children: React.ReactNode[]}) => {
  const [activePreview, setActivePreview] = React.useState(0);
  const timerRef = React.useRef(null);
  const hasUserSelect = React.useRef(false);

  React.useEffect(() => {
    if (hasUserSelect.current === false) {
      const timerId = setTimeout(() => {
        setActivePreview((activePreview + 1) % children.length);
      }, 7000);

      timerRef.current = timerId;
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [activePreview]);

  return (
    <div className={styles.chartPreviewContainer}>
      <div style={{width: `420px`, height: `280px`}} className={styles.chartAnimation} key={activePreview}>
        {children[activePreview]}
      </div>
      <div className={styles.dial}>
        {children.map((_, ind) => {
          return (
            <SvgIconReact
              key={ind}
              icon={`status-light`}
              color={ind === activePreview ? `#4F44E0` : `#e5e5e6`}
              onClick={() => {
                setActivePreview(ind);
                clearInterval(timerRef.current);
                hasUserSelect.current = true;
              }}
            />
          );
        })}
      </div>
    </div>
  );
};
